<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <custom-popup
        v-model="dialog"
        :cons="cons"
        max-width="640"
        @close="resetFields"
      >
        <template v-slot:helpinfo>
          <help-info
            :element-name="`${serviceName}-${componentName}-select-default-product-name`"
            :service-name="serviceName"
            :help-data="helpData"
            class="buttoninfo"
            :label="$t('productPicker.select_default_product')"
          />
        </template>
        <v-card :loading="loading || products_loading" class="pa-md-2" flat>
          <v-card-title>
            <div class="rowinfo" style="width: 100% !important">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                class="rounded-lg contentinfo"
                clearable
                dense
                hide-details
                :label="$t('productPicker.search')"
                outlined
                @input="searchInput"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-search`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('productPicker.search')"
              />
            </div>
          </v-card-title>

          <v-card-title
            v-if="
              breadcrumbs.length &&
              breadcrumbs[0].text !== '/' &&
              (!search || search.length < 2)
            "
            id="bread-title"
            class="flex-nowrap"
          >
            <v-btn
              v-if="breadcrumbs.length && breadcrumbs[0].text !== '/'"
              :icon="!$vuetify.breakpoint.mobile"
              depressed
              @click="handleBreadClick(breadcrumbs[breadcrumbs.length - 1])"
            >
              <v-icon>mdi-chevron-right</v-icon>
              <span class="d-md-none">{{ $t("productPicker.back") }}</span>
            </v-btn>

            <!--      <v-breadcrumbs-->
            <v-breadcrumbs :items="breadcrumbs">
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item
                  class="cursor-pointer"
                  @click="handleBreadClick(item)"
                >
                  {{ item.text }}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>

            <v-spacer />
            <div
              class="rowinfo"
              :disabled="
                loading ||
                products_loading ||
                !products.data ||
                !products.data.length
              "
            >
              <v-btn
                :disabled="
                  loading ||
                  products_loading ||
                  !products.data ||
                  !products.data.length
                "
                :loading="loading"
                class="btn-accept ma-0"
                depressed
                @click="selectAll"
              >
                {{ $t("productPicker.select_all_products") }}
              </v-btn>
              <help-info
                :element-name="`${serviceName}-${componentName}-products-select-all`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('productPicker.select_all_products')"
              />
            </div>
          </v-card-title>

          <v-expand-transition>
            <div v-if="!search || search.length < 2">
              <v-list-item
                v-for="(cat, i) in categories.filter(
                  (item) => item.parent_id === parent_id,
                )"
                :key="i"
                dense
                @click="selectCat(cat)"
              >
                <v-list-item-avatar>
                  <v-img :src="cat.icon" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title v-text="cat.title" />
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon>
                    <v-icon>mdi-chevron-left</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </div>
          </v-expand-transition>

          <div v-if="products_loading" class="text-center pa-4">
            <v-progress-circular indeterminate size="50" width="5" />
          </div>

          <v-row
            v-show="!products_loading && !!products.data && !!products.data.length"
            class="ma-2"
            no-gutters
          >
            <v-col
              v-for="(item, i) in products.data"
              :key="i"
              class="pa-2"
              cols="12"
              md="6"
            >
              <v-card
                :class="{ 'active-item': selectedItems.has(item.id) }"
                class="rounded-lg fill-height d-flex align-center"
                outlined
                @click="selectProduct(item.id)"
              >
                <v-list-item>
                  <v-list-item-avatar
                    :size="$vuetify.breakpoint.mobile ? 64 : 98"
                    class="rounded-lg"
                  >
                    <v-img :src="item.data.gallery[0].images[0].url" />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="text-wrap" v-text="item.title" />
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>

            <v-col class="px-8 pt-2" cols="12" md="6">
              <v-select
                v-model="pageLength"
                :items="[10, 16, 24, 50, 100]"
                class="rounded-lg"
                dense
                hide-details
                :label="$t('productPicker.no_products_in_category')"
                outlined
              />
            </v-col>

            <v-col class="pa-2" cols="12">
              <pagination :data="products" @page="onPagination" />
            </v-col>
          </v-row>

          <v-card-text v-if="breadcrumbs.length > 1" class="text-center">
            {{ $t("productPicker.no_products_in_category") }}
          </v-card-text>

          <v-card-actions
            v-if="breadcrumbs.length > 1 && getProductsHasError"
            class="justify-center"
          >
            <div class="text-center">
              {{ $t("productPicker.products_error") }} <br />
              <v-btn
                class="mt-2 rounded-lg"
                color="warning"
                depressed
                @click="onPagination(page, true)"
              >
                <v-icon left>mdi-reload</v-icon>
                {{ $t("productPicker.retry") }}
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </custom-popup>
    </template>
  </help-info-wrapper>
</template>

<script>
import Pagination from "@/view/content/fragments/pagination.vue";
import { debounce } from "@/main";

export default {
  name: "productPicker",

  components: { Pagination },

  props: {
    value: Boolean,
    categoryId: [Number, null],
    selectedCat: Object,
    isModelList: Boolean,
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "productPicker",

      categories: [],

      breadcrumbs: [
        {
          text: "/",
          disabled: true,
          href: "",
        },
      ],
      products: [],
      parent_id: null,
      loading: false,
      products_loading: false,
      selectedItems: new Set([]),
      search: "",
      counter: 0,
      pageLength: 10,
      page: 1,
      getProductsHasError: false,
    };
  },

  computed: {
    cons() {
      return {
        title: this.$t("productPicker.select_default_product"),
        buttons: [{ type: "submit", handler: this.saveItems }],
      };
    },
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
    dialog(val) {
      if (val) {
        if (!!this.selectedCat?.ids_list?.length)
          this.selectedItems = new Set(this.selectedCat.ids_list);
        this.fetchCategories();
        this.getProducts(this.categoryId);
      } else this.selectedItems = new Set();
    },
  },

  methods: {
    saveItems() {
      if (!this.isModelList) this.$emit("save", Array.from(this.selectedItems));
    },
    fetchCategories() {
      this.loading = true;
      this.breadcrumbs = [
        {
          text: "/",
          disabled: true,
          href: "",
        },
      ];

      this.$api
        .get(this.$qrApi + "/admin/category")
        .then(({ data }) => {
          this.categories = data.data;

          let parent = (this.parent_id =
            this.selectedCat.temp_id ?? this.selectedCat.source_id);
          let cat = data.data.find((item) => item.id === parent);

          if (cat != null) {
            let bread = [];

            try {
              while (!!parent) {
                cat = data.data.find((item) => item.id === parent);
                bread.push({
                  text: cat?.title,
                  disabled: false,
                  href: "",
                  id: cat?.parent_id,
                });

                this.breadcrumbs = bread;
                parent = cat?.parent_id;
              }

              if (!!bread?.length) {
                this.$nextTick(() => {
                  // bread.reverse();
                  // this.breadcrumbs = bread;
                  this.breadcrumbs = [...bread.reverse(), ...this.breadcrumbs];
                });
              }
            } catch (e) {
              console.log(e);
            }
          } else this.parent_id = null;
        })
        .catch(({ response }) =>
          console.log("failed to get categories data: ", response),
        )
        .finally(() => (this.loading = false));
    },
    getProducts(id = undefined, search) {
      this.products_loading = true;
      this.counter++;

      this.$api
        .get(this.$qrApi + "/template", {
          params: {
            length: this.pageLength,
            category: id,
            page: this.page,
            search,
          },
        })
        .then(({ data }) => {
          this.getProductsHasError = false;
          this.products = data.data;
        })
        .catch(({ response }) => {
          this.getProductsHasError = true;
        })
        .finally(() => {
          if (this.counter > 0) this.counter--;

          this.$nextTick(() => {
            if (!this.counter) this.products_loading = false;
          });
        });
    },
    selectCat(cat) {
      if (this.breadcrumbs[0].text === "/") this.breadcrumbs.pop();

      this.getProducts(cat.id);

      this.$nextTick(() => {
        this.breadcrumbs.push({
          text: cat.title,
          disabled: false,
          href: "",
          id: cat.parent_id,
        });
      });
      this.parent_id = cat.id;
    },
    onPagination(e, reload = false) {
      if (e !== this.page || reload) {
        this.page = e;
        this.$nextTick(() => {
          if (!this.search || this.search.length < 2) this.getProducts(this.parent_id);
          else this.getProducts(undefined, this.search);
        });
      }
    },
    selectProduct(id) {
      if (this.selectedItems.has(id)) {
        this.selectedItems.delete(id);
        if (this.isModelList) this.$emit("remove", id);
      } else {
        this.selectedItems.add(id);
        if (this.isModelList) this.$emit("add", id);
      }

      this.$forceUpdate();
    },
    handleBreadClick(item) {
      this.getProducts(item.id);

      this.parent_id = item.id;
      let bread = this.breadcrumbs;
      let index = bread.findIndex((b) => b.id === item.id);
      do {
        bread.pop();
      } while (bread.length >= index + 1);
      this.breadcrumbs = bread;
      this.$nextTick(() => {
        if (!this.breadcrumbs.length)
          this.breadcrumbs.push({
            text: "/",
            disabled: true,
            href: "",
          });
      });
    },
    resetFields() {
      this.parent_id = null;
      this.breadcrumbs = [
        {
          text: "/",
          disabled: true,
          href: "",
        },
      ];
    },
    searchInput(e) {
      debounce(() => {
        if (e?.length >= 2) this.getProducts(undefined, e);
        else this.getProducts(this.parent_id);
      }, 1000);
    },
    selectAll() {
      this.loading = true;
      let arr = [];

      for (const item of this.products.data) {
        if (!this.selectedItems.has(item.id)) {
          this.selectedItems.add(item.id);
          if (this.isModelList) arr.push(item.id);
        }
      }

      if (!this.isModelList) this.$emit("saveBulk", arr);
      else this.$emit("addBulk", arr);

      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
  },
};
</script>

<style scoped>
.active-item {
  border-color: #0bb7af !important;
}

.active-item >>> .v-list-item__title {
  color: #0bb7af !important;
}
</style>
